import { Divider } from '@mui/material'
import { PrivacyType } from '@weblite/ts-action/user-policy'
import {
  UserListItemSkeleton,
  SelectableUserListItemWithStatus,
} from '$common/user-list-item'
import { UserChip } from '$common/user-chip'
import { withMultiSelectSearchableListPage } from '$common/multi-select-searchable-list-page'
import { EmptyStateList } from '$common/empty-state-list'
import { closeAddPrivacyExceptionUsers } from '$logic/router'
import { useFamiliarUserIds, useSearchedFamiliarUserIds } from '$logic/users'
import { setUserPolicy } from '$logic/user-policy'
import { t } from '$i18n'

const ListItem = ({
  id,
  selected,
  onSelectedChange,
}: {
  id: string
  selected: boolean
  onSelectedChange: (isSelected: boolean) => unknown
}) => (
  <>
    <SelectableUserListItemWithStatus
      userId={id}
      selected={selected}
      hasDivider={false}
      onSelectedChange={onSelectedChange}
    />
    <Divider variant="inset" />
  </>
)

export function AddPrivacyExceptionUsers({
  privacyType,
  exceptionType,
}: {
  privacyType: PrivacyType
  exceptionType: 'never' | 'always'
}) {
  const Page = withMultiSelectSearchableListPage<
    { id: string },
    null,
    { query: string; items: { id: string }[] }
  >({
    appBarTitle: t(`settings.privacy.exception.${exceptionType}`),
    SkeletonItem: UserListItemSkeleton,
    EmptyStateComponent: () => <EmptyStateList />,
    fetchHook: useFamiliarUserIds,
    searchHook: useSearchedFamiliarUserIds,
    ChipComponent: UserChip,
    selectionPrimaryKey: 'id',
    onBack: closeAddPrivacyExceptionUsers,
    onConfirm: async selectedItems => {
      const succeed = await setUserPolicy(
        privacyType,
        selectedItems.map(({ id }) => id),
        exceptionType === 'never' ? 'EXCLUDE' : 'INCLUDE',
      )
      if (succeed) closeAddPrivacyExceptionUsers()
    },
  })

  return (
    <Page
      fetchHookParams={null}
      getSearchHookParams={(query, items) => ({ query, items })}
      ListItem={ListItem}
    />
  )
}
